import redirectURL from "../redirectURL";
import DatePicker from 'react-datepicker'
import Select from 'react-select';
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from 'react';
import SweetAlert from "react-bootstrap-sweetalert";
import { getDecoder, getHyphenDDMMMYYYYHHMM, sortingDatesInGrid } from "../common/utils";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import ReportCounters from './ReportCounters.js';

const ConsignmentTrackingReport = () => {

    const columnApiConsignments = useRef(null);
    const user = useMemo(() => getDecoder(), []);
    const [loader, setLoader] = useState(false)
    const [show, setShow] = useState(false)
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    const [searchZone, setSeachZone] = useState('');
    const [searchPlant, setSearchPlant] = useState('');
    const [startDate, setStartDate] = useState(new Date(moment().startOf('month')));
    const [monthSelected, setMonthSelected] = useState(new Date(2025, 2)); // March is month index 2
    const [endDate, setEndDate] = useState(new Date(moment().parseZone()));
    const [zones, setZone] = useState([]);
    const [plants, setPlants] = useState([]);
    const [allPlants, setAllPlants] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [rowFoData, setRowFoData] = useState([]);
    const [detailCellRendererParams, setdetailCellRendererParams] = useState(null);
    const [counters, setCounters] = useState({
        total_fo_numbers: [],
        approved_fo_numbers: [],
        tracking_mode: [],
        gps_mode_count: [],
        sim_mode_count: [],
        event_pushed_count: [],
        super_tracking_count: [],
        super_tracking_percentage: [],
        gate_in_count: [],
        gate_out_count: [],
        dealer_in_count: [],
        dealer_out_count: [],
    })
    const [counterData, setCounterData] = useState({
        total_fos: [],
        approved_fos: [],
        tracking_mode: [],
        events_pushed: [],
        super_tracking: [],
        gps_mode: [],
        sim_mode: [],
        gate_in: [],
        gate_out: [],
        dealer_in: [],
        dealer_out: []
    })
    const defaultColDef = useMemo(() => {
        return {
            sortable: true,
            filter: true,
            autoSizeColumns: true,
            resizable: true,
            pivot: true,
        }
    }, []);
    const closeAlert = () => {
        setShow(false)
        setTitle('')
        setType('default')
    }

    const handleStartDateChange = (date) => {
        if (endDate && date > endDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setStartDate(date)
        }
    };

    const handleEndDateChange = (date) => {
        if (startDate && date < startDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setEndDate(date)
        }
    }

    useEffect(() => {
        getFoData()
    }, [])
    const submitFoEvent = async (e) => {
        e.preventDefault()
        getFoData()
    }

    const getFoData = async () => {
        setLoader(true)
        let query = {
            sdate: moment.parseZone(startDate).utcOffset("+05:30").format("YYYY-MM-DD"),
            edate: moment.parseZone(endDate).utcOffset("+05:30").format("YYYY-MM-DD")
        }
        await redirectURL.post('consignments/getFoLevelBilling', query)
            .then((response) => {
                setLoader(false)
                let foOverAllDf = response.data?.overall_df ?? [];
                setRowFoData(foOverAllDf)
                const {
                    total_fo_numbers,
                    approved_fo_numbers,
                    tracking_type_counts,
                    super_tracked_fo_numbers,
                    super_tracking_fo_percentage,
                    prev_month_supr_tracking_percentage,
                    event_counts,
                    overall_df = []
                } = response.data || {};
                console.log('4657890-', response.data)
                const foData = {
                    total: total_fo_numbers?.data || [],
                    totalCount: total_fo_numbers?.count || 0,
                    approved: approved_fo_numbers?.data || [],
                    approvedCount: approved_fo_numbers?.count || 0,
                    gps: {
                        ids: tracking_type_counts?.GPS?.data || [],
                        count: tracking_type_counts?.GPS?.count || 0
                    },
                    sim: {
                        ids: tracking_type_counts?.SIM?.data || [],
                        count: tracking_type_counts?.SIM?.count || 0
                    },
                    superTracked: {
                        ids: super_tracked_fo_numbers?.data || [],
                        count: super_tracked_fo_numbers?.count || 0
                    }
                };
                const tracking = {
                    totalIds: [...(foData.gps.ids || []), ...(foData.sim.ids || [])],
                    totalCount: (foData.gps.count || 0) + (foData.sim.count || 0),
                    perviousMonth: prev_month_supr_tracking_percentage,
                    currentMonth: super_tracking_fo_percentage,
                    performance: super_tracking_fo_percentage > prev_month_supr_tracking_percentage ? 'profit' : 'loss'
                };
                const events = {
                    gateIn: event_counts?.plant_in?.data || [],
                    gateOut: event_counts?.plant_out?.data || [],
                    dealerIn: event_counts?.dealer_in?.data || [],
                    dealerOut: event_counts?.dealer_out?.data || [],
                    gateInCount: event_counts?.plant_in?.count || 0,
                    gateOutCount: event_counts?.plant_out?.count || 0,
                    dealerInCount: event_counts?.dealer_in?.count || 0,
                    dealerOutCount: event_counts?.dealer_out?.count || 0,
                };
                const combinedEvents = [
                    ...events.gateIn,
                    ...events.gateOut,
                    ...events.dealerIn,
                    ...events.dealerOut
                ];
                const eventPushedCount =
                    events.gateInCount +
                    events.gateOutCount +
                    events.dealerInCount +
                    events.dealerOutCount;

                const filters = {
                    totalFOData: overall_df.filter(item => foData.total.includes(item._id)),
                    totalApprovedFOData: overall_df.filter(item => foData.approved.includes(item._id)),
                    trackingFilterData: overall_df.filter(item => tracking.totalIds.includes(item._id)),
                    gpsFOData: overall_df.filter(item => foData.gps.ids.includes(item._id)),
                    simFOData: overall_df.filter(item => foData.sim.ids.includes(item._id)),
                    superTrackedFOData: overall_df.filter(item => foData.superTracked.ids.includes(item._id)),
                    gateInFOData: overall_df.filter(item => events.gateIn.includes(item._id)),
                    gateOutFOData: overall_df.filter(item => events.gateOut.includes(item._id)),
                    dealerInFOData: overall_df.filter(item => events.dealerIn.includes(item._id)),
                    dealerOutFOData: overall_df.filter(item => events.dealerOut.includes(item._id)),
                    totalEventFOData: overall_df.filter(item => combinedEvents.includes(item._id))
                };
                setCounterData({
                    total_fos: filters.totalFOData,
                    approved_fos: filters.totalApprovedFOData,
                    tracking_mode: filters.trackingFilterData,
                    gps_mode: filters.gpsFOData,
                    sim_mode: filters.simFOData,
                    events_pushed: filters.totalEventFOData,
                    super_tracking: filters.superTrackedFOData,
                    gate_in: filters.gateInFOData,
                    gate_out: filters.gateOutFOData,
                    dealer_in: filters.dealerInFOData,
                    dealer_out: filters.dealerOutFOData
                });

                setCounters({
                    total_fo_numbers: foData.totalCount,
                    approved_fo_numbers: foData.approvedCount,
                    tracking_mode: tracking.totalCount,
                    gps_mode_count: foData.gps.count,
                    sim_mode_count: foData.sim.count,
                    event_pushed_count: eventPushedCount,
                    super_tracking_count: foData.superTracked.count,
                    super_tracking_percentage: tracking.performance,
                    gate_in_count: events.gateInCount,
                    gate_out_count: events.gateOutCount,
                    dealer_in_count: events.dealerInCount,
                    dealer_out_count: events.dealerOutCount,
                    previousMonth: tracking.perviousMonth,
                    currentMonth: tracking.currentMonth,
                });
            })
            .catch((error) => {
                setLoader(false)
                console.error('Error fetching data:', error);
            })
    }
    const CounterClick = (ecounter, i = 0) => {
        switch (ecounter) {
            case "total_fo_numbers":
                setRowFoData(counterData.total_fos)
                break;
            case "approved_fo_numbers":
                setRowFoData(counterData.approved_fos)
                break;
            case "tracking_mode":
                setRowFoData(counterData.tracking_mode)
                break;
            case "gps_mode_count":
                setRowFoData(counterData.gps_mode)
                break;
            case "sim_mode_count":
                setRowFoData(counterData.sim_mode)
                break;
            case "event_pushed_count":
                setRowFoData(counterData.events_pushed)
                break;
            case "super_tracking_count":
                setRowFoData(counterData.super_tracking)
                break;
            case "gate_in_count":
                setRowFoData(counterData.gate_in)
                break;
            case "gate_out_count":
                setRowFoData(counterData.gate_out)
                break;
            case "dealer_in_count":
                setRowFoData(counterData.dealer_in)
                break;
            case "dealer_out_count":
                setRowFoData(counterData.dealer_out)
                break;
            default:
                setRowFoData('')
                break;
        }
    }
    const columnDefs = useMemo(() => {
        return [
            {
                headerName: "FO Number",
                width: 125,
                field: "fo_number",
            },
            {
                headerName: "Status",
                width: 125,
                field: "",
                valueGetter: function (params) {
                    if (params.data.status == 1) {
                        if (params.data.gate_in_time == undefined || params.data.gate_in_time == null || params.data.gate_in_time == "") {
                            if (params.data?.manual_gate_in == undefined || params.data?.manual_gate_in == null || params.data?.manual_gate_in == "")
                                return "Consignment Created"
                            return "Inside Plant"
                        }
                        else
                            return "Inside Plant";
                    }
                    else if (params.data.status == 2) {
                        return "In Transit";
                    }
                    else if (params.data.status == 3) {
                        return "Near Customer";
                    }
                    else if (params.data.status == 4) {
                        return "Reached Customer";
                    }
                    else if (params.data.status == 5) {
                        return "Left Customer";
                    }
                    else if (params.data.status == 6) {
                        return "Force Closed";
                    }
                    else if (params.data.status == 7) {
                        return "Proximity Trip Closure";
                    }
                    else if (params.data.status == 8) {
                        return "Cancelled";
                    }
                    else if (params.data.status == 9) {
                        return "Trip Closed";
                    }
                    else {
                        return "N/A";
                    }
                }
            },
            {
                headerName: "Sim Consent Status",
                width: 125,
                field: "sim_tracking_state",
                valueGetter: function (params) {
                    try {
                        if (params.data.tracking_mode == "GPS")
                            return "Approved"
                        else {
                            if (params.data.sim_tracking_state == 1 || params.data.sim_tracking_state == 2 || params.data.sim_tracking_state == 14 || params.data.prob_service_provider == "bsnl") {
                                return "Not Registered";
                            }
                            else if (params.data.sim_tracking_state == 3 || params.data.sim_tracking_state == 18) {
                                return "Approved";
                            }
                            else if (params.data.sim_tracking_state == 4 || params.data.sim_tracking_state == 7 || params.data.sim_tracking_state == 12 ||
                                params.data.sim_tracking_state == 15 || params.data.sim_tracking_state == 16 ||
                                params.data.sim_tracking_state == 17 || params.data.sim_tracking_state == 19 ||
                                params.data.sim_tracking_state == 20 || params.data.sim_tracking_state == 21 ||
                                params.data.sim_tracking_state == 23 || params.data.sim_tracking_state == 24 ||
                                params.data.sim_tracking_state == 25 || params.data.sim_tracking_state == 26) {
                                return "Consent Approved";
                            }
                            else if (params.data.sim_tracking_state == 5 || params.data.sim_tracking_state == 6 || params.data.sim_tracking_state == 11 || params.data.sim_tracking_state == 22) {
                                return "Consent Pending";
                            }
                            else if (params.data.sim_tracking_state == 8 || params.data.sim_tracking_state == 10) {
                                return "Consent Declined";
                            }
                            else if (params.data.sim_tracking_state == 9 || params.data.sim_tracking_state == 18) {
                                return "Approved";
                            }
                            else if (params.data.sim_tracking_state == 13) {
                                return "Error";
                            }
                            else if (params.data.sim_tracking_state == 14 || params.data.prob_service_provider == "bsnl") {
                                return "Not Registered";
                            }
                        }
                    }
                    catch (e) {
                        // console.log(e)
                    }
                },
            },
            {
                headerName: "Truck No.",
                width: 125,
                field: "truck_no",
            },
            {
                headerName: 'Tracking Mode',
                field: 'tracking_mode',
                width: 150
            },
            {
                headerName: "Mobile Gate In",
                field: "manual_gate_in",
                width: 144,
                valueGetter: function (params) {
                    if (params.data?.manual_gate_in != undefined && params.data?.manual_gate_in != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data?.manual_gate_in)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Mobile Gate Out",
                field: "manual_gate_out",
                valueGetter: function (params) {
                    if (params.data?.manual_gate_out != undefined && params.data?.manual_gate_out != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data?.manual_gate_out)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                width: 144
            },
            {
                headerName: "Geofence Gate In",
                field: "gate_in_time",
                valueGetter: function (params) {
                    if (params.data.gate_in_time != undefined && params.data.gate_in_time != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.gate_in_time)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                width: 144
            },
            {
                headerName: "Geofence Gate Out",
                field: "gate_out_time",
                valueGetter: function (params) {
                    if (params.data.gate_out_time != undefined && params.data.gate_out_time != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.gate_out_time)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                width: 144
            },
            {
                headerName: "Plant Code",
                field: "consigner_code",
                width: 120,
                editable: true,

            },
            {
                headerName: "Plant Name",
                field: "consigner_name",
                width: 130,
                valueGetter: function (params) {
                    return !['', undefined, null].includes(params.data.consigner_name) ? params.data.consigner_name : '';
                }
            },
            {
                headerName: "Customer Code",
                field: "consignee_code",
                editable: true,
            },
            {
                headerName: "Customer Name",
                field: "consignee_name"
            },
            {
                headerName: "Reached Customer",
                field: "recent_dealer_reported",
                width: 144,
            },
            {
                headerName: "Left Customer",
                field: "left_dealer_marked",
                width: 144,
            },
            {
                headerName: "Driver Name",
                field: "driver_name",
                width: 128,
                editable: true,
                valueGetter: function (params) {
                    return !['', null, undefined].includes(params.data.driver_name) ? params.data.driver_name : ''
                }
            },
            {
                headerName: "Driver Phone No.",
                field: "driver_mobile_no",
                width: 128,
                editable: true,
            },

        ]
    }, []);

    const columnDefs2 = useMemo(() => {
        return [
            {
                headerName: "FO Number",
                field: "fo_number",
            },
            {
                headerName: "Vehicle No.",
                field: "truck_no",
            },
            {
                headerName: "Driver No.",
                field: "driver_mobile_no",
            },
            {
                headerName: "Created Date",
                field: "created_date",
                valueGetter: function (params) {
                    if (params.data.created_date != undefined && params.data.created_date != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.created_date)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
        ]
    }, []);

    const onCellClicked = (params) => {
        let rowData = params.data
        if (rowData[params.colDef.field]?.data != undefined && Array.isArray(rowData[params.colDef.field]?.data)) {
            params.node.setExpanded(!params.node.expanded)
            setdetailCellRendererParams({
                detailGridOptions: {
                    columnDefs: columnDefs2,
                    defaultColDef: {
                        flex: 1,
                    },
                },
                getDetailRowData: (params2) => {
                    params2.successCallback(rowData[params.colDef.field]?.data);
                },
            })
        }
    }

    const onChangeZone = (selected) => {
        if (selected.find(e => e.value === "ALL")) {
            setSeachZone([{ label: "ALL", value: "ALL" }])
            setPlants(allPlants.map(e => e.consigner).flat())
        }
        else {
            let selectedValues = selected.map(e => e.value)
            let temp = allPlants.filter(e => selectedValues.includes(e._id) ?? []).map(s => s?.consigner ?? []).flat()
            setPlants([...[{ label: "ALL", value: "ALL" }], ...temp])
            setSeachZone(selected)
        }
    }

    const onChangePlant = (selected) => {
        if (selected.find(e => e.value === "ALL"))
            setSearchPlant([{ label: "ALL", value: "ALL" }])
        else
            setSearchPlant(selected)
    }

    return (
        <div className="container-fluid">
            <SweetAlert
                show={show}
                type={type}
                title={title}
                onConfirm={closeAlert}
            >
            </SweetAlert>
            <h5 className="mb-15p fbold f16">
                <i className="icon-map cus-i"></i> <span style={{ fontWeight: "600" }}>FO Level Report</span>
            </h5>
            <div className="row">
                <div className="col-xl-12 col-lg-12">
                    <div className="col-xl-12 col-lg-12">
                        <div>
                            <div class="row" style={{ alignItems: "center", marginBottom: "25px", width: '100%' }}>

                                <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-2">
                                    <div className="d-flex align-items-center"><label className="" style={{ whiteSpace: "nowrap", minWidth: "120px" }}>
                                        FO Created From Date</label></div>
                                    <div className="">
                                        <DatePicker
                                            selected={startDate}
                                            onChange={handleStartDateChange}
                                            name="startDate"
                                            autoComplete="off"
                                            dateFormat="dd/MM/yyyy"
                                            className="datepicker-custom"
                                            maxDate={new Date()}
                                        />
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-2">
                                    <div className="d-flex align-items-center"><label className="" style={{ whiteSpace: "nowrap", minWidth: "120px" }}>
                                        FO Created To Date</label></div>
                                    <div className="">
                                        <DatePicker
                                            selected={endDate}
                                            onChange={handleEndDateChange}
                                            name="endDate"
                                            autoComplete="off"
                                            dateFormat="dd/MM/yyyy"
                                            className="datepicker-custom"
                                            maxDate={new Date()}
                                        />
                                    </div>
                                </div>
                                <div className="form-group col-xl-1 col-lg-1">
                                    <label>&nbsp;&nbsp;&nbsp;</label><br />
                                    <button type="button" onClick={submitFoEvent} className={"btn btn-success "} id="report-submit">Submit</button>
                                </div>
                            </div>
                            <ReportCounters {...counters} setCounter={CounterClick} />
                            <div className="card">
                                <div className="card-body row">
                                    {/* < h5 className="" style={{ paddingTop: "6px",paddingLeft:'14px' }}>FO Level Report</h5> */}

                                    <div id="ctr-gird" className={"ag-theme-balham mt-8"} style={{ height: '500px', width: '100%', paddingTop: "1rem" }}>
                                        <AgGridReact
                                            ref={columnApiConsignments}
                                            columnDefs={columnDefs}
                                            suppressAutoColumns={true}
                                            rowData={rowFoData}
                                            defaultColDef={defaultColDef}
                                            pagination={true}
                                            groupHeaderHeight={50}
                                            headerHeight={50}
                                            paginationPageSize={50}
                                            enableRangeSelection={true}
                                            enableCellContextMenu={true}
                                            masterDetail={true}
                                            detailCellRendererParams={detailCellRendererParams}
                                            onCellClicked={onCellClicked}
                                            sideBar={{
                                                toolPanels: [
                                                    {
                                                        id: "columns",
                                                        labelDefault: "Columns",
                                                        labelKey: "columns",
                                                        iconKey: "columns",
                                                        toolPanel: "agColumnsToolPanel",
                                                        toolPanelParams: {
                                                            suppressPivotMode: true,
                                                            suppressRowGroups: true,
                                                            suppressValues: true,
                                                        }
                                                    },
                                                    {
                                                        id: "filters",
                                                        labelDefault: "Filters",
                                                        labelKey: "filters",
                                                        iconKey: "filter",
                                                        toolPanel: "agFiltersToolPanel"
                                                    }
                                                ]
                                            }}
                                            statusBar={{
                                                statusPanels: [
                                                    {
                                                        statusPanel: "agTotalAndFilteredRowCountComponent",
                                                        align: "left"
                                                    },
                                                    {
                                                        statusPanel: "agTotalRowCountComponent",
                                                        align: "center"
                                                    },
                                                    { statusPanel: "agFilteredRowCountComponent" },
                                                    { statusPanel: "agSelectedRowCountComponent" },
                                                    { statusPanel: "agAggregationComponent" }
                                                ]
                                            }}
                                        />
                                    </div>
                                </div></div>
                        </div> </div>
                    {/* <div className="card">
                    //     <div className="card-body row">
                    //     < h5 className="" style={{ paddingTop: "6px",paddingLeft:'14px' }}>Delivery Level Report</h5>                            <div className="col-xl-12 col-lg-12 row">
                    //             <div className="col-xl-2 col-lg-2 form-group">
                    //                 <div className=""><label>Created From Date</label></div>
                    //                 <div className="">
                    //                     <DatePicker
                    //                         selected={startDate}
                    //                         onChange={handleStartDateChange}
                    //                         name="startDate"
                    //                         autoComplete="off"
                    //                         dateFormat="dd/MM/yyyy"
                    //                         className="datepicker-custom"
                    //                     />
                    //                 </div>
                    //             </div>
                    //             <div className="col-xl-2 col-lg-2 form-group">
                    //                 <div className=""><label>Created To Date</label></div>
                    //                 <div className="">
                    //                     <DatePicker
                    //                         selected={endDate}
                    //                         onChange={handleEndDateChange}
                    //                         name="endDate"
                    //                         autoComplete="off"
                    //                         dateFormat="dd/MM/yyyy"
                    //                         className="datepicker-custom"
                    //                     />
                    //                 </div>
                    //             </div>
                    //             <div className="form-group col-xl-3 col-lg-3" style={{ zIndex: "8" }}>
                    //                 <label>Select Zone</label>
                    //                 <Select
                    //                     className="border-radius-0"
                    //                     id="searchZone"
                    //                     style={{ borderRadius: "0px" }}
                    //                     value={searchZone}
                    //                     onChange={onChangeZone}
                    //                     options={zones}
                    //                     isMulti={true}
                    //                 />
                    //             </div>
                    //             <div className="form-group col-xl-3 col-lg-3" style={{ zIndex: "8" }}>
                    //                 <label>Select Plant </label>
                    //                 <Select
                    //                     className="border-radius-0"
                    //                     isMulti={true}
                    //                     id="searchPlant"
                    //                     style={{ borderRadius: "0px" }}
                    //                     value={searchPlant}
                    //                     onChange={onChangePlant}
                    //                     options={plants}
                    //                 />
                    //             </div>
                    //             <div className="form-group col-xl-1 col-lg-1">
                    //                 <button type="button" style={{ marginTop: "35px" }} onClick={submitEvent} className={"btn btn-success "}>Submit</button>
                    //             </div>
                    //         </div>
                    //         <div id="ctr-gird" className={"ag-theme-balham mt-8"} style={{ height: '500px', width: '100%', paddingTop: "1rem" }}>
                    //             <AgGridReact
                    //                 ref={columnApiConsignments}
                    //                 columnDefs={columnDefs3}
                    //                 rowData={rowData}
                    //                 defaultColDef={defaultColDef}
                    //                 pagination={true}
                    //                 groupHeaderHeight= {50}
                    //                 headerHeight= {50}
                    //                 paginationPageSize={50}
                    //                 enableRangeSelection={true}
                    //                 enableCellContextMenu={true}
                    //                 masterDetail={true}
                    //                 detailCellRendererParams={detailCellRendererParams}
                    //                 onCellClicked={onCellClicked}
                    //                 sideBar={{
                    //                     toolPanels: [
                    //                         {
                    //                             id: "columns",
                    //                             labelDefault: "Columns",
                    //                             labelKey: "columns",
                    //                             iconKey: "columns",
                    //                             toolPanel: "agColumnsToolPanel",
                    //                             toolPanelParams: {
                    //                                 suppressPivotMode: true,
                    //                                 suppressRowGroups: true,
                    //                                 suppressValues: true,
                    //                             }
                    //                         },
                    //                         {
                    //                             id: "filters",
                    //                             labelDefault: "Filters",
                    //                             labelKey: "filters",
                    //                             iconKey: "filter",
                    //                             toolPanel: "agFiltersToolPanel"
                    //                         }
                    //                     ]
                    //                 }}
                    //                 statusBar={{
                    //                     statusPanels: [
                    //                         {
                    //                             statusPanel: "agTotalAndFilteredRowCountComponent",
                    //                             align: "left"
                    //                         },
                    //                         {
                    //                             statusPanel: "agTotalRowCountComponent",
                    //                             align: "center"
                    //                         },
                    //                         { statusPanel: "agFilteredRowCountComponent" },
                    //                         { statusPanel: "agSelectedRowCountComponent" },
                    //                         { statusPanel: "agAggregationComponent" }
                    //                     ]
                    //                 }}
                    //             />
                    //         </div>
                    //     </div>
                    </div> } */}
                </div>
            </div>
            <div className={"dataLoadpage " + (loader ? "show-m" : "show-n")}></div>
            <div className={"dataLoadpageimg " + (loader ? "show-m" : "show-n")} style={{ top: "21em" }}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
        </div>
    )
}
export default ConsignmentTrackingReport;